/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { SxProps } from "@mui/material";
import { IFilterSelectBox } from "../../../Shared/Filter/types";
import { useSelector } from "react-redux";
import { useStoreDispatch } from "../../../../store/hooks";
import { setSelectedDeviceStatus } from "../../../../store/filters/Nodes/reducer";
import { devicesSelector } from "../../../../store/filters/Nodes/selectors";
import { constStr } from "../../../../globals/constants";

export const useMigrationFilter = () => {
  const filterSelector = useSelector(devicesSelector);
  const dispatch = useStoreDispatch();

  const filters: IFilterSelectBox[] = [
    {
      id: "migrationstatus",
      label: "MIGRATION STATUS",
      value: filterSelector.selectedDeviceStatus || "",
      setValue: setSelectedDeviceStatus,
      values: Object.keys(constStr.migrateStatus),
      width: "200px",
    },
  ];

  const formControlSx: SxProps = { minWidth: 100, marginRight: "10px" };
  const searchTooltip = "Search by 'Name', 'IP Address', or 'Serial Number' fields for quick access.";
  return {
    dispatch,
    filters,
    formControlSx,
    searchTooltip,
  };
};
